import { useQuery } from 'data-fetching-client';
import { CURRENCY } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_IN_APP_CURRENCIES } from 'pricing-pages-api/currency/queries';
import { useGetCurrencyStore, useSetCurrencyStore } from '../../../context/CurrencyContext';
import { isAvailableCurrencyCode } from '../../utils/typeguards';
const UseSetLoadingCurrencyComplete = () => {
  const setStore = useSetCurrencyStore();
  const handleCurrencyFetchCompleted = ({
    currencies
  }) => {
    setStore(currencies);
  };
  return handleCurrencyFetchCompleted;
};
export const useInAppCurrencies = () => {
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();
  const {
    data,
    error,
    loading
  } = useQuery(GET_IN_APP_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY
    },
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const useDisplayedCurrencyCode = () => {
  const currencyCode = useGetCurrencyStore(store => store.displayedCurrencyCode);
  if (isAvailableCurrencyCode(currencyCode)) {
    return currencyCode;
  }
  return 'USD';
};
export const useLockedCurrencyCode = () => {
  const currencyCode = useGetCurrencyStore(store => store.lockedCurrencyCode);
  return currencyCode;
};
export const useCurrencyCodeUnitToDisplay = () => {
  const currencyCodeUnit = useGetCurrencyStore(store => store.currencyCodeUnit);
  const showCurrencyCodeUnit = useGetCurrencyStore(store => store.showCurrencyCodeUnit);
  return showCurrencyCodeUnit ? currencyCodeUnit : undefined;
};
export const useAvailableCurrencyCodes = () => {
  const availableCurrencyCodes = useGetCurrencyStore(store => store.availableCurrencyCodes);
  return availableCurrencyCodes.filter(isAvailableCurrencyCode);
};
export const useCountryCode = () => {
  const countryCode = useGetCurrencyStore(store => store.countryCode);
  return countryCode || undefined;
};